import { Box } from "@mui/material";
import InputText from "../../../components/form/inputText";
import PasswordStrengthBar from "react-password-strength-bar";
import { PasswordField } from "../../../components";

export const Credential = ({ formik }) => {
  return (
    <>
      <InputText
        placeholder={"Email"}
        value={formik.values.email}
        onChange={formik.handleChange}
        helperText={formik.errors.email}
        name={"email"}
        error={formik.touched.email && Boolean(formik.errors.email)}
      />
      <Box>
        <PasswordField
          mode={"input"}
          placeholder={"Password"}
          value={formik.values.password}
          onChange={formik.handleChange}
          helperText={formik.errors.password}
          name={"password"}
          type={"password"}
          error={formik.touched.password && Boolean(formik.errors.password)}
        />
        {formik.values.password ? (
          <PasswordStrengthBar password={formik.values.password} />
        ) : null}
      </Box>
      <PasswordField
        mode={"input"}
        placeholder={"Re-type Password"}
        value={formik.values.retypePassword}
        onChange={formik.handleChange}
        helperText={formik.errors.retypePassword}
        name={"retypePassword"}
        type={"password"}
        error={
          formik.touched.retypePassword && Boolean(formik.errors.retypePassword)
        }
      />
    </>
  );
};
